import React from 'react';
import { useT } from '../lib/i18n';

/**
 * Compact EN | FR toggle. Lives in the Header. Keeps the active language
 * highlighted in dark-crimson, the other in muted gold so it reads as
 * "you can switch".
 */
const LanguageToggle = ({ className = '' }) => {
  const { lang, setLang, t } = useT();
  const base = 'text-xs tracking-[0.2em] font-semibold transition-colors px-2 py-1';
  const active = 'text-dark-crimson';
  const muted = 'text-dark-green/40 hover:text-dark-green';
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="lang-toggle">
      <button
        type="button"
        data-testid="lang-en"
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
        className={`${base} ${lang === 'en' ? active : muted}`}
        style={{ fontFamily: 'Cormorant Garamond, serif' }}
      >
        {t('lang.en')}
      </button>
      <span className="text-gold/60">|</span>
      <button
        type="button"
        data-testid="lang-fr"
        aria-pressed={lang === 'fr'}
        onClick={() => setLang('fr')}
        className={`${base} ${lang === 'fr' ? active : muted}`}
        style={{ fontFamily: 'Cormorant Garamond, serif' }}
      >
        {t('lang.fr')}
      </button>
    </div>
  );
};

export default LanguageToggle;
